import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from '@phosphor-icons/react';

const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-dark" data-testid="datenschutz-page">
      {/* Header */}
      <header className="border-b border-white/10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-white/60 hover:text-gold transition-colors text-sm"
            data-testid="datenschutz-back-link"
          >
            <ArrowLeft size={16} />
            Zurück zur Startseite
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="py-12 md:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h1 className="font-serif text-3xl sm:text-4xl text-white mb-8">Datenschutzerklärung</h1>

            <div className="prose prose-invert max-w-none text-white/70 space-y-8">
              <section>
                <h2 className="font-serif text-xl text-white mb-4">1. Datenschutz auf einen Blick</h2>
                
                <h3 className="text-lg text-white/90 mt-6 mb-3">Allgemeine Hinweise</h3>
                <p>
                  Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren 
                  personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene 
                  Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
                </p>

                <h3 className="text-lg text-white/90 mt-6 mb-3">Datenerfassung auf dieser Website</h3>
                <p>
                  <strong className="text-white">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
                  Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. 
                  Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
                </p>
                <p>
                  <strong className="text-white">Wie erfassen wir Ihre Daten?</strong><br />
                  Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. 
                  Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben.
                </p>
              </section>

              <section>
                <h2 className="font-serif text-xl text-white mb-4">2. Verantwortliche Stelle</h2>
                <p>
                  veNta Grundbesitz GmbH<br />
                  Neudörferstraße 5<br />
                  90402 Nürnberg<br />
                  <br />
                  Telefon: 0911 94 98 0 99<br />
                  E-Mail: info@venta-immobilien.de
                </p>
              </section>

              <section>
                <h2 className="font-serif text-xl text-white mb-4">3. Datenschutzbeauftragter</h2>
                <p>
                  Wir haben für unser Unternehmen einen Datenschutzbeauftragten bestellt:
                </p>
                <p>
                  <strong className="text-white">Brigitte Neises</strong><br />
                  Telefon: +49 160 1505303<br />
                  E-Mail: b.neises@venta-immobilien.de
                </p>
              </section>

              <section>
                <h2 className="font-serif text-xl text-white mb-4">4. Ihre Rechte</h2>
                <p>Sie haben jederzeit das Recht auf:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Auskunft über Ihre gespeicherten personenbezogenen Daten</li>
                  <li>Berichtigung unrichtiger Daten</li>
                  <li>Löschung Ihrer Daten</li>
                  <li>Einschränkung der Verarbeitung</li>
                  <li>Datenübertragbarkeit</li>
                  <li>Widerspruch gegen die Verarbeitung</li>
                </ul>
              </section>

              <section>
                <h2 className="font-serif text-xl text-white mb-4">5. Kontaktformular</h2>
                <p>
                  Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben 
                  aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten 
                  zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns 
                  gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
                </p>
                <p>
                  Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, 
                  sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur 
                  Durchführung vorvertraglicher Maßnahmen erforderlich ist.
                </p>
              </section>

              <section>
                <h2 className="font-serif text-xl text-white mb-4">6. Cookies</h2>
                <p>
                  Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf 
                  Ihrem Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, 
                  unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen.
                </p>
                <p>
                  Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs oder 
                  zur Bereitstellung bestimmter, von Ihnen erwünschter Funktionen erforderlich sind, 
                  werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert.
                </p>
              </section>

              <section>
                <h2 className="font-serif text-xl text-white mb-4">7. Meta Pixel (Facebook Pixel)</h2>
                <p>
                  Diese Website nutzt zur Konversionsmessung das Besucheraktions-Pixel von Meta 
                  (ehemals Facebook). Anbieter dieser Dienste ist die Meta Platforms Ireland Ltd., 
                  4 Grand Canal Square, Dublin 2, Irland.
                </p>
                <p>
                  <strong className="text-white">Datensatz ID:</strong> 1784624072279856
                </p>
                <p>
                  Das Meta Pixel wird nur aktiviert, wenn Sie der Verwendung von analytischen 
                  Cookies zugestimmt haben. Sie können Ihre Einwilligung jederzeit widerrufen, 
                  indem Sie die Cookie-Einstellungen im Footer dieser Website ändern.
                </p>
                <p>
                  Folgende Events können erfasst werden:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>PageView (Seitenaufruf)</li>
                  <li>ViewContent (Betrachtung von Inhalten)</li>
                  <li>Lead (Absenden des Kontaktformulars)</li>
                  <li>Contact (Klick auf Kontaktmöglichkeiten)</li>
                </ul>
              </section>

              <section>
                <h2 className="font-serif text-xl text-white mb-4">8. SSL/TLS-Verschlüsselung</h2>
                <p>
                  Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung 
                  vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte 
                  Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von 
                  „http://" auf „https://" wechselt.
                </p>
              </section>

              <section>
                <h2 className="font-serif text-xl text-white mb-4">9. Beschwerderecht</h2>
                <p>
                  Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht 
                  bei einer Aufsichtsbehörde zu. Die für uns zuständige Aufsichtsbehörde ist:
                </p>
                <p>
                  Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen<br />
                  Kavalleriestraße 2-4<br />
                  40213 Düsseldorf
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-white/10 py-6">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-white/40 text-xs">
              © {new Date().getFullYear()} veNta Grundbesitz GmbH
            </p>
            <div className="flex gap-6">
              <Link to="/impressum" className="text-white/40 hover:text-gold text-xs transition-colors">
                Impressum
              </Link>
              <Link to="/" className="text-white/40 hover:text-gold text-xs transition-colors">
                Startseite
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Datenschutz;
